export const ru = {
    'home-screen-title': 'Главная',
    'create-call': 'Собрать звонок',
    'home-screen-sub-title': 'Звонки',
    'create-call-button': 'Собрать звонок вне встречи',
    'create-call-button-short': 'Собрать звонок',
};
